import { Connection } from 'src/ui/graph/types';

export type EndpointAuthType = 'org-sso' | 'sso' | 'browser-auth' | 'username';

export const getEndpointAuthType = (connection: Connection) => {
  let authType: EndpointAuthType;
  if (connection.useSSO && connection.usesOrgSso) {
    authType = 'org-sso';
  } else if (connection.useSSO) {
    authType = 'sso';
  } else if (!connection.username) {
    authType = 'browser-auth';
  } else {
    authType = 'username';
  }
  return authType;
};
